<template>
  <div>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'fullName'"
          class="text-nowrap"
        >
          <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.fullName }}</span>
        </div>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'notifications'">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(props.row.notifications)"
              size="18"
              class="mr-50"
              :color="colorRoleIcon(props.row.notifications)"
            />
          </div>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                v-b-modal.modal-lg
                @click="store = props.row.id, report.length = 0"
              >
                <feather-icon
                  icon="FileTextIcon"
                  class="mr-50"
                />
                <span>Relatórios</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <b-modal
      id="modal-lg"
      ok-only
      ok-title="fechar"
      centered
      size="lg"
      title="Relatório"
    >

      <b-row class="match-height">
        <!-- range -->
        <b-col md="4">
          <b-form-group>
            <h5>Período</h5>
            <flat-pickr
              v-model="rangeDate"
              class="form-control"
              :config="{ mode: 'range'}"
              placeholder="período da busca"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-button
            id="getReport"
            type="reset"
            variant="outline-secondary"
            @click="getReport()"
          >
            Gerar Relatório
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <ecommerce-company-table
          :table-data="report"
        />
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BRow, BCol, BSpinner, BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import { getUserData } from '@/auth/utils'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { getStoresUserActived } from '../../../functions/basics/stores'
import { reportTransactions } from '../../../functions/Report/report'
import EcommerceCompanyTable from '../../dashboard/ecommerce/EcommerceCompanyTable.vue'

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    vSelect,
    flatPickr,
    EcommerceCompanyTable,
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Nome',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Procure pelo nome',
          },
        },
        {
          label: 'Notificação',
          field: 'notifications',
          filterOptions: {
            enabled: true,
            placeholder: '1 - conectado 0 - desconectado',
          },
        },
        {
          label: 'Administrador',
          field: 'admin',
          filterOptions: {
            enabled: true,
            placeholder: 'nome do administrador',
          },
        },
        {
          label: 'Ação',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      resolveUserRoleIcon: role => {
        if (role === 1) return 'CheckCircleIcon'
        if (role === 0) return 'XCircleIcon'
      },
      colorRoleIcon: role => {
        if (role === 1) return 'green'
        if (role === 0) return 'grey'
      },
      rangeDate: null,
      store,
      report: null,
      totalContactados: 0,
      totalConvertidos: 0,
      payment: {
        1: 'Carrinho abandonado', 2: 'Boleto', 3: 'Cartão de Crédito', 4: 'CArtão de Débito', 5: 'Paypal', 6: 'Pix', 7: 'Transferência Bancária', 8: 'Moip', 9: 'Bcash', 10: 'Hotmart', 11: 'Mercado Pago', 12: 'Boleto + Cartão', 13: 'Addi', 14: 'PagaLeve', 15: 'Ame', 16: 'Pix Parcelado', 17: 'Koin', 18: '2 Cartões', 19: '', 20: '', 21: '', 22: '', 23: 'NuPay', 24: 'Marketplace',
      },
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current      : 'light-primary',
        Professional : 'light-success',
        Rejected     : 'light-danger',
        Resigned     : 'light-warning',
        Applied      : 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  async created() {
    const userData = await getUserData()
    this.rows = await getStoresUserActived(userData.mc_access_token)
  },
  methods: {
    async getReport() {
      const button = document.querySelector('#getReport')
      button.disabled = true
      const dataRange = this.rangeDate.replace(' ', '').split('to')
      const reportList = await reportTransactions(0, this.store, dataRange[0], dataRange[1], 2).finally(() => { button.disabled = false })
      // Criar variaveis
      const data = []

      const geral = []

      const reportData = []

      for (let i = 1; i <= 24; i++) {
        data[i] = {}
        data[i].convertidos = {}
        data[i].contactados = 0
        data[i].TotalConvertidos = 0
        data[i].ValorTotalContatados = 0

        geral[i] = {}
        geral[i].convertidos = 0
        geral[i].total = 0

        for (let j = 1; j <= 24; j++) {
          data[i].convertidos[j] = []
          data[i].convertidos[j].qtd = 0
          data[i].convertidos[j].total = 0
        }
      }

      // formatar dados
      await reportList.attendings.forEach(element => {
        // contactados por tipo de pagamento
        data[element.first_transaction.payment_id].contactados += 1

        if (element.last_transaction) {
          // numero de após primeiro contato
          data[element.first_transaction.payment_id].TotalConvertidos += 1
          // Valor convertido
          data[element.first_transaction.payment_id].ValorTotalContatados += parseFloat(element.last_transaction.amount)

          // Quantidade e total por tipo de pagamento de finalização após o primeiro contato. Ex: Boleto finalizado no cartão
          data[element.first_transaction.payment_id].convertidos[element.last_transaction.payment_id].qtd += 1
          data[element.first_transaction.payment_id].convertidos[element.last_transaction.payment_id].total += parseFloat(element.last_transaction.amount)

          geral[element.last_transaction.payment_id].total += parseFloat(element.last_transaction.amount)
          geral[element.last_transaction.payment_id].convertidos += 1
        }
      })

      // Tabela
      await data.forEach((value, key) => {
        if (value.contactados !== 0) {
          const porcent = ((value.TotalConvertidos * 100) / value.contactados)
          const { ValorTotalContatados } = value

          reportData.push({
            FormaPagamento: this.payment[key], contactados: value.contactados, convertidos: value.TotalConvertidos, total: ValorTotalContatados.toLocaleString('pt-br', { minimumFractionDigits: 2 }), porcent: parseFloat(porcent.toFixed(2)),
          })

          this.totalContactados += value.contactados
          this.totalConvertidos += value.TotalConvertidos
        }
      })

      this.report = reportData

      console.log(this.report)
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
